import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";

export default function DashboardWrapper(props: any) {
  const router = useRouter();
  const userToken = useSelector((state: any) => {
    return state.auth.accessToken;
  });

  useEffect(() => {
    if (!userToken) {
      if (router?.isReady) {
        router.push("/");
      }
    }
  }, []);

  return userToken ? props.children : null;
}
